module.exports = __webpack_public_path__ + "img/soundwave.7ae849fd.svg";